import styles from './index.module.css';
import { Icon } from '../../components/Icons';
import { messages } from '../../utils/messages';

function ComponentNoDataFound(props) {
  const { type, message } = props;
  switch (type) {
    case 'nodataavialable':
      return (
        <div className={`${styles.messageDiv}`}>
          <div className={`${styles.text} ${styles.exceptionErr}`}>
            <Icon name="robot" width={115} height={156} />
            <div
              className={`${styles.font18} ${styles.baseStyle}`}
            >{`${message}`}</div>
            {/* <div className={`${styles.font11} ${styles.baseStyle}`}>
              <a
                href="https://docs.lambdatest.com/display/TD/Selenium+Automation+Capabilities"
                target="_blank"
              >{`${messages.NODATA.LEARN_MORE}`}</a>
            </div> */}
          </div>
        </div>
      );
    case 'raw-logs':
      return (
        <div className={`${styles.messageDivRowLogs}`}>
          <div className={`${styles.text} ${styles.rawLogs}`}>
            <Icon name="robot-old" width={115} height={156} />
            <div
              className={`${styles.font18} ${styles.baseStyle} ${styles.messageDivTextColor}`}
            >{`${message}`}</div>
          </div>
        </div>
      );
    default:
      return (
        <div className={`${styles.messageDiv}`}>
          <div className={`${styles.font18} ${styles.text}`}>
            {messages.NODATA.DEFAULT}
          </div>
        </div>
      );
  }
}

export default ComponentNoDataFound;
